<template>
  <main-layout>

    <div slot="left-side">
      <menubar screenIdParam="M-06-24"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title>
        <label slot="title">{{ $t("label.router.CalendarEdit") }}</label>
        <lvory-but
          v-if="this.$authCodeCheck('010611')"
          slot="cancel"
          class="header-clear-btn"
          @click="backPage">
          {{ $t("button.common.cancel") }}
        </lvory-but>
        <!-- v-if="this.$authCodeCheck('014001')" -->
        <narrow-down
          v-if="this.$authCodeCheck('010611')"
          slot="create"
          class="header-save-btn"
          @click="editGoogleCalendarAuth">
          {{ $t("button.common.data.create") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">

      <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 40px;">
        連携対象設定
      </div>

      <div style="margin-bottom: 40px;display: flex;align-items: center;">
        <div style="margin-right: 16px;">
          <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 20px;line-height: 30px;color: #525250;">
            テナント一括設定
          </div>
          <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 12px;line-height: 18px;color: #525250;">
            ※アカウントごとの設定は不可となります
          </div>
        </div>
        <div style="margin-right: 56px;">
          <el-switch
            v-model="form.collectiveSettingFlag"
            :disabled="!$authCodeCheck('010611')"
            :active-value="true"
            :inactive-value="false">
          </el-switch>
        </div>
        <div style="margin-right: 29px;font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 20px;line-height: 30px;color: #525250;">
          連携対象
        </div>
        <div style="margin-right: 10px;font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;line-height: 18px;color: #525250;">
          施設
        </div>
        <el-switch
          style="margin-right: 30px;"
          v-model="form.meetingRoomRezSyncFlag"
          :disabled="!form.collectiveSettingFlag || !$authCodeCheck('010611')"
          :active-value="true"
          :inactive-value="false">
        </el-switch>
        <div style="margin-right: 10px;font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 300;font-size: 16px;line-height: 18px;color: #525250;">
          指定席
        </div>
        <el-switch
          v-model="form.fixDeskRezSyncFlag"
          :disabled="!form.collectiveSettingFlag || !$authCodeCheck('010611')"
          :active-value="true"
          :inactive-value="false">
        </el-switch>
      </div>
      <div style="height: 1px;width: 800px;background-color: #D1D1CD;margin-bottom: 40px;" />
      <div style="font-family: 'Hiragino Kaku Gothic Pro';font-style: normal;font-weight: 600;font-size: 20px;line-height: 18px;color: #525250;margin-bottom: 40px;">
        Googleカレンダー認証情報編集
      </div>

      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="form"
        class="c-auth-form"
        label-width="188px"
        label-position="left"
        hide-required-asterisk>

        <!-- ドメイン -->
        <el-form-item
          v-if="this.$authCodeCheck('010611')"
          prop="domain"
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.googleAuth.domain')">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.domain">
          </el-input>
        </el-form-item>

        <el-form-item
          v-else
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.googleAuth.domain')">
          <div class="domain">
            <span>{{ form.domain }}</span>
          </div>
        </el-form-item>

        <!-- クライアントID -->
        <el-form-item
          v-if="this.$authCodeCheck('010611')"
          prop="clientID"
          class="m-bottom-5 client-id"
          :label="'クライアントID'">
          <el-input
            class="new-input-shadow"
            maxlength="256"
            v-model="form.clientID">
          </el-input>
        </el-form-item>

        <!-- シークレットキー -->
        <el-form-item
          v-if="this.$authCodeCheck('010611')"
          prop="secretKey"
          class="last-input-sp"
          :label="'シークレットキー'">
          <el-input
            class="new-input-shadow"
            :rows="5"
            type="textarea"
            v-model="form.secretKey"
            maxlength="3000">
          </el-input>
          <img @click="form.secretKey = null" class="iot-popover-image-size" src="@/assets/icon/close-btn.svg" alt="">
        </el-form-item>

      </el-form>

      <div
        class="c-auth-save-btn"
      >
        <narrow-down
          v-if="this.$authCodeCheck('010611')"
          style="margin-left: 170px;"
          @click="editGoogleCalendarAuth">
          {{ $t("button.common.data.save") }}
        </narrow-down>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import HeadTitle from "@/components/common/head/head"
import MainLayout from "@/layout/NewDesignLayout"
import NarrowDown from "@/components/common/generalButton/NarrowDown"
import errorCodeMsg from "@/utils/error-code-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import SystemManageApi from "@/api/SystemManageApi"
import GoogleCalendarAuthRuleFactory from "@/rules/rule-tenant-calendar-edit.js"

export default {
  name: "TenantCalendarAuth",
  components: {
    Menubar: Menubar,
    LvoryBut: LvoryBut,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    NarrowDown: NarrowDown,
    LoadingDialog: LoadingDialog
  },
  data() {
    return {
      isClearBtn: false,
      saveIsShow: false,
      saveMsgParam: this.$t("message.common.validation.updateMessage", {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }),
      deleteIsShow: false,
      deleteMsgParam: this.$t("message.common.validation.confDelete", {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }),
      showLoading: false,
      rules: GoogleCalendarAuthRuleFactory.googleCalendarAuthRules(this),
      tenantId: null,
      form: {
        collectiveSettingFlag: false,
        meetingRoomRezSyncFlag: false,
        fixDeskRezSyncFlag: false,
        domain: null,
        clientID: null,
        secretKey: null
      }
    }
  },
  created() {
    var breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/tenants/search",
        title: "label.router.Thetenant",
      },
      {
        path: "",
        title: "label.router.tenantDetail",
      },
      {
        path: "",
        title: "label.router.CalendarEdit",
      },
    ];

    if (this.$IsTenantUser()) {
      breadcrumb.splice(2,1)
    }
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  mounted() {
    this.tenantId = this.$route.params.tenantId
    this.getGoogleCalendarAuth()
  },
  methods: {

    getGoogleCalendarAuth() {
      this.showLoading = true
      SystemManageApi.detailCalendar(this.tenantId)
      .then(({data}) => {
        if (data.body != null && data.body != undefined && data.body != "") {
          this.form.collectiveSettingFlag = data.body.collectiveSettingFlag
          this.form.meetingRoomRezSyncFlag = data.body.meetingRoomRezSyncFlag
          this.form.fixDeskRezSyncFlag = data.body.fixDeskRezSyncFlag
          this.form.domain = data.body.domain
          this.form.clientID = data.body.clientID
          this.form.secretKey = data.body.secretKey
        }
      })
      .catch((error) => {
        this.isClearBtn = false
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.showLoading = false
      })
    },

    editGoogleCalendarAuth() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          if (
              (!this.$IsNullOrEmpty(this.form.domain) && !this.$IsNullOrEmpty(this.form.clientID) && !this.$IsNullOrEmpty(this.form.secretKey)) ||
              (this.$IsNullOrEmpty(this.form.domain) && this.$IsNullOrEmpty(this.form.clientID) && this.$IsNullOrEmpty(this.form.secretKey))
            ) {

              let checkFlag = false
              if (!this.$IsNullOrEmpty(this.form.secretKey)) {
                if (this.$checkSpecialKeyWord(this.form.secretKey)) {
                  checkFlag = true
                  this.$messageIotError(this.$t('message.common.validation.inputSpecialKeyword',{
                      field: "シークレットキー",
                      keyWord: "<、>、\"、'"
                  }))
                }
              }

              if (!checkFlag) {
                this.editAuthInfo()
              }
          } else {
            this.$messageIotError('Googleの認証に失敗しました。入力内容をご確認ください。')
          }
        }
      })
    },

    editAuthInfo() {
      let request = {
        tenantId: this.tenantId,
        domain: this.form.domain,
        clientID: this.form.clientID,
        secretKey: this.form.secretKey,
        meetingRoomRezSyncFlag: this.form.meetingRoomRezSyncFlag,
        collectiveSettingFlag: this.form.collectiveSettingFlag,
        fixDeskRezSyncFlag: this.form.fixDeskRezSyncFlag
      }
      this.doneEditGoogleCalendarAuth(request)
    },

    doneEditGoogleCalendarAuth(req) {
      this.showLoading = true
      SystemManageApi.updateCalendar(req)
        .then(({data}) => {
          if (data.statusCode == "Success") {
            this.$messageIotSuccess(this.$t("message.common.save"))
            this.getGoogleCalendarAuth()
          } else if (data.statusCode == "Failure.Failure_AuthParameterIncorrect" || data.statusCode == "Failure.Failure_GoogleAuthFailed") {
            this.$messageIotError(this.$t('message.common.error.ERR_GOOGLE_CALENDAR_AUTH'))
          }
        })
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .finally(() => {
          this.showLoading = false
        })
    },

    backPage () {
      this.$router.push({
        name: "system-tenant-detail",
        params: {
          tenantId: this.tenantId,
        }
      })
    }

  }
}
</script>

<style scoped lang="scss">
.header-save-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.header-clear-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.c-auth-form::v-deep {
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-input__inner {
    height: 44px !important;
  }
  .el-form-item__label {
    font-size: 16px;
  }
}
.c-auth-save-btn {
  margin-left: 188px;
  margin-top: 60px;
}
.domain {
  color: #525250;
  font-size: 14px;
}
.client-id::v-deep {
  .el-input .el-input__inner {
    width: 528px;
  }
}
::v-deep .new-input-shadow .el-input__inner {
  background: #F7F7F2 !important;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  border-radius: 8px;
}
::v-deep .new-input-shadow .el-textarea__inner {
  background: #F7F7F2 !important;
  box-shadow: inset 3px 3px 3px #DEDED1, inset -3px -3px 4px #FFFFFA !important;
  border-radius: 8px;
}
.iot-popover-image-size {
  position: relative;
  cursor: pointer;
  top: -170px;
  left: 500px;
  height: 18px;
}
::v-deep .last-input-sp .el-form-item__content .el-form-item__error {
  margin-top: -40px;
}
</style>
